import { createFileRoute } from "@tanstack/react-router";

import { ScheduleWorkspace } from "../components/schedule/ScheduleWorkspace";

export type ScheduleWorkspaceSearch = {
  readonly view: "host" | "definitions";
  readonly environment?: string;
  readonly project?: string;
};

export const Route = createFileRoute("/_chat/schedule")({
  validateSearch: (search: Record<string, unknown>): ScheduleWorkspaceSearch => ({
    view: search.view === "definitions" ? "definitions" : "host",
    ...(typeof search.environment === "string" && search.environment.length > 0
      ? { environment: search.environment }
      : {}),
    ...(typeof search.project === "string" && search.project.length > 0
      ? { project: search.project }
      : {}),
  }),
  component: ScheduleWorkspace,
});
